var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMessageNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6.75a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.85 4.96c-.13-.61-.14-1.2-.03-1.76a.988.988 0 0 0-.97-1.2H7C4.24 2 2 4.24 2 7v6.95c0 2.76 2.24 5 5 5h1.5c.28 0 .64.18.8.4l1.5 1.99c.66.88 1.74.88 2.4 0l1.5-1.99a1 1 0 0 1 .8-.4h1.51c2.76 0 4.99-2.23 4.99-4.99V9.15c0-.63-.58-1.09-1.2-.97-.56.1-1.15.1-1.76-.03a4.226 4.226 0 0 1-3.19-3.19zM7 11c0-.55.44-1 1-1 .55 0 1 .45 1 1s-.44 1-1 1-1-.45-1-1zm4 0c0-.55.44-1 1-1 .55 0 1 .45 1 1s-.44 1-1 1-1-.45-1-1zm4 0c0-.55.44-1 1-1 .55 0 1 .45 1 1s-.44 1-1 1-1-.45-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMessageNotif);
export default __webpack_public_path__ + "static/media/vuesax-bold-message-notif.707139b64fc7e172953448b56ba3b629.svg";
export { ForwardRef as ReactComponent };